import(/* webpackMode: "eager" */ "/home/ubuntu/download/6960ee637683ed00148142db/mafa_press/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6960ee637683ed00148142db/mafa_press/src/app/about-the-book/components/PressKit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6960ee637683ed00148142db/mafa_press/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6960ee637683ed00148142db/mafa_press/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6960ee637683ed00148142db/mafa_press/src/components/ui/AppImage.tsx");
